import { BulkReplacementRadio } from '../../components/BulkReplacementModeChooser/BulkReplacementModeChooser';
import { ErrorItem } from '../../components/ErrorsPresenter/ErrorsPresenter';
import { TrackingParametersReplacementSelect } from '../../components/TrackingParametersBulkReplacement/TrackingParametersBulkReplacement';
import { BannerId } from '../../typings/banners';
import {
    EditorBannerPriceId,
    MassActionId,
    ProtocolValue
} from '../../typings/bannersEditState';
import { AdvType, BannerImageForEdit } from '../../typings/domain';

import { OnAcceptBulkImageReplacementAction } from './banner-text-image';

export const OPEN_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR =
    'OPEN_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR';
export type OPEN_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR = typeof OPEN_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR;
export interface OpenMassActionsLinkBulkReplacementEditorAction {
    type: OPEN_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function openMassActionsLinkBulkReplacementEditor(
    massActionId: MassActionId
): OpenMassActionsLinkBulkReplacementEditorAction {
    return {
        type: OPEN_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const OPEN_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR =
    'OPEN_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR';
export type OPEN_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR = typeof OPEN_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR;
export interface OpenMassActionsLinkBulkPathReplacementEditorAction {
    type: OPEN_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function openMassActionsLinkBulkPathReplacementEditor(
    massActionId: MassActionId
): OpenMassActionsLinkBulkPathReplacementEditorAction {
    return {
        type: OPEN_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const CLOSE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR =
    'CLOSE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR';
export type CLOSE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR = typeof CLOSE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR;
export interface CloseMassActionsLinkBulkPathReplacementEditorAction {
    type: CLOSE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function closeMassActionsLinkBulkPathReplacementEditor(
    massActionId: MassActionId
): CloseMassActionsLinkBulkPathReplacementEditorAction {
    return {
        type: CLOSE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_TARGET_PART_URL_EDITOR =
    'CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_TARGET_PART_URL_EDITOR';
export type CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_TARGET_PART_URL_EDITOR = typeof CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_TARGET_PART_URL_EDITOR;

export interface ChangeMassActionsLinkBulkPathReplacementTargetPartUrlEditorAction {
    type: CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_TARGET_PART_URL_EDITOR;
    targetPartUrl: string;
    massActionId: MassActionId;
}

export const changeMassActionsLinkBulkPathReplacementTargetPartUrlEditor = (
    targetPartUrl: string,
    massActionId: MassActionId
): ChangeMassActionsLinkBulkPathReplacementTargetPartUrlEditorAction => {
    return {
        type: CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_TARGET_PART_URL_EDITOR,
        targetPartUrl,
        massActionId
    };
};

export const CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_NEW_PART_URL_EDITOR =
    'CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_NEW_PART_URL_EDITOR';
export type CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_NEW_PART_URL_EDITOR = typeof CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_NEW_PART_URL_EDITOR;

export interface ChangeMassActionsLinkBulkPathReplacementNewPartUrlEditorAction {
    type: CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_NEW_PART_URL_EDITOR;
    newPartUrl: string;
    massActionId: MassActionId;
}

export const changeMassActionsLinkBulkPathReplacementNewPartUrlEditor = (
    newPartUrl: string,
    massActionId: MassActionId
): ChangeMassActionsLinkBulkPathReplacementNewPartUrlEditorAction => {
    return {
        type: CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_NEW_PART_URL_EDITOR,
        newPartUrl,
        massActionId
    };
};

export const CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_DOMAIN_TUMBLER_EDITOR =
    'CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_DOMAIN_TUMBLER_EDITOR';
export type CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_DOMAIN_TUMBLER_EDITOR = typeof CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_DOMAIN_TUMBLER_EDITOR;
export interface ChangeMassActionsLinkBulkPathReplacementDomainTumblerEditorAction {
    type: CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_DOMAIN_TUMBLER_EDITOR;
    massActionId: MassActionId;
}

export function changeMassActionsLinkBulkPathReplacementDomainTumblerEditor(
    massActionId: MassActionId
): ChangeMassActionsLinkBulkPathReplacementDomainTumblerEditorAction {
    return {
        type: CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_DOMAIN_TUMBLER_EDITOR,
        massActionId
    };
}

export const CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_PARAMETER_TUMBLER_EDITOR =
    'CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_PARAMETER_TUMBLER_EDITOR';
export type CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_PARAMETER_TUMBLER_EDITOR = typeof CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_PARAMETER_TUMBLER_EDITOR;
export interface ChangeMassActionsLinkBulkPathReplacementParameterTumblerEditorAction {
    type: CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_PARAMETER_TUMBLER_EDITOR;
    massActionId: MassActionId;
}

export function changeMassActionsLinkBulkPathReplacementParameterTumblerEditor(
    massActionId: MassActionId
): ChangeMassActionsLinkBulkPathReplacementParameterTumblerEditorAction {
    return {
        type: CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_PARAMETER_TUMBLER_EDITOR,
        massActionId
    };
}

export const CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_SITE_LINKS_TUMBLER_EDITOR =
    'CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_SITE_LINKS_TUMBLER_EDITOR';
export type CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_SITE_LINKS_TUMBLER_EDITOR = typeof CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_SITE_LINKS_TUMBLER_EDITOR;

export interface ChangeMassActionsLinkBulkPathReplacementSiteLinksTumblerEditorAction {
    type: CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_SITE_LINKS_TUMBLER_EDITOR;
    massActionId: MassActionId;
}

export const changeMassActionsLinkBulkPathReplacementSiteLinksTumblerEditor = (
    massActionId: MassActionId
): ChangeMassActionsLinkBulkPathReplacementSiteLinksTumblerEditorAction => {
    return {
        type: CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_SITE_LINKS_TUMBLER_EDITOR,
        massActionId
    };
};

export const ON_ACCEPT_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR =
    'ON_ACCEPT_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR';
export type ON_ACCEPT_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR = typeof ON_ACCEPT_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR;

export interface OnAcceptMassActionsLinkBulkPathReplacementEditorAction {
    type: ON_ACCEPT_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export const onAcceptMassActionsLinkBulkPathReplacementEditor = (
    massActionId: MassActionId
): OnAcceptMassActionsLinkBulkPathReplacementEditorAction => {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR,
        massActionId
    };
};

export const CHANGE_LINK_BULK_EDITOR_SELECTED_LINK =
    'CHANGE_LINK_BULK_EDITOR_SELECTED_LINK';
export type CHANGE_LINK_BULK_EDITOR_SELECTED_LINK = typeof CHANGE_LINK_BULK_EDITOR_SELECTED_LINK;
export interface ChangeLinkBulkEditorSelectedLinkAction {
    type: CHANGE_LINK_BULK_EDITOR_SELECTED_LINK;
    selectedSourceItems: string;
    massActionId: MassActionId;
}

export function changeLinkBulkEditorSelectedLink(
    selectedSourceItems: string,
    massActionId: MassActionId
): ChangeLinkBulkEditorSelectedLinkAction {
    return {
        type: CHANGE_LINK_BULK_EDITOR_SELECTED_LINK,
        selectedSourceItems,
        massActionId
    };
}

export const CHANGE_LINK_BULK_EDITOR_PROTOCOL_LINK =
    'CHANGE_LINK_BULK_EDITOR_PROTOCOL_LINK';
export type CHANGE_LINK_BULK_EDITOR_PROTOCOL_LINK = typeof CHANGE_LINK_BULK_EDITOR_PROTOCOL_LINK;
export interface ChangeLinkBulkEditorProtocolLinkAction {
    type: CHANGE_LINK_BULK_EDITOR_PROTOCOL_LINK;
    selectedProtocolValue: ProtocolValue;
    massActionId: MassActionId;
}

export function changeLinkBulkEditorProtocolLink(
    selectedProtocolValue: ProtocolValue,
    massActionId: MassActionId
): ChangeLinkBulkEditorProtocolLinkAction {
    return {
        type: CHANGE_LINK_BULK_EDITOR_PROTOCOL_LINK,
        selectedProtocolValue,
        massActionId
    };
}

export const CHANGE_LINK_BULK_EDITOR_NEW_LINK =
    'CHANGE_LINK_BULK_EDITOR_NEW_LINK';
export type CHANGE_LINK_BULK_EDITOR_NEW_LINK = typeof CHANGE_LINK_BULK_EDITOR_NEW_LINK;
export interface ChangeLinkBulkEditorNewLinkAction {
    type: CHANGE_LINK_BULK_EDITOR_NEW_LINK;
    newVisibleLink: string;
    massActionId: MassActionId;
}

export function changeLinkBulkEditorNewLink(
    newVisibleLink: string,
    massActionId: MassActionId
): ChangeLinkBulkEditorNewLinkAction {
    return {
        type: CHANGE_LINK_BULK_EDITOR_NEW_LINK,
        newVisibleLink,
        massActionId
    };
}

export const ON_ACCEPT_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR =
    'ON_ACCEPT_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR';
export type ON_ACCEPT_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR = typeof ON_ACCEPT_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR;
export interface OnAcceptMassActionsLinkBulkReplacementEditorAction {
    type: ON_ACCEPT_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function onAcceptMassActionsLinkBulkReplacementEditor(
    massActionId: MassActionId
): OnAcceptMassActionsLinkBulkReplacementEditorAction {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ON_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR_TUMBLER_CHANGED =
    'ON_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR_TUMBLER_CHANGED';
export type ON_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR_TUMBLER_CHANGED = typeof ON_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR_TUMBLER_CHANGED;
export interface OnMassActionsLinkBulkReplacementEditorTumblerChangedAction {
    type: ON_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR_TUMBLER_CHANGED;
    massActionId: MassActionId;
}

export function onMassActionsLinkBulkReplacementEditorTumblerChanged(
    massActionId: MassActionId
): OnMassActionsLinkBulkReplacementEditorTumblerChangedAction {
    return {
        type: ON_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR_TUMBLER_CHANGED,
        massActionId
    };
}

export const SAVE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR =
    'SAVE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR';
export type SAVE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR = typeof SAVE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR;
export interface SaveMassActionsLinkBulkReplacementEditorAction {
    type: SAVE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
    isSiteLinkEnabled: boolean;
    domain: string;
}

export function saveMassActionsLinkBulkReplacementEditor(
    massActionId: MassActionId,
    isSiteLinkEnabled: boolean,
    domain: string
): SaveMassActionsLinkBulkReplacementEditorAction {
    return {
        type: SAVE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR,
        massActionId,
        isSiteLinkEnabled,
        domain
    };
}

export const SAVE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR =
    'SAVE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR';
export type SAVE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR = typeof SAVE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR;
export interface SaveMassActionsLinkBulkPathReplacementEditorAction {
    type: SAVE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
    isSiteLinkEnabled: boolean;
    domains?: Record<BannerId, string>;
}

export function saveMassActionsLinkBulkPathReplacementEditor(
    massActionId: MassActionId,
    isSiteLinkEnabled: boolean,
    domains?: Record<BannerId, string>
): SaveMassActionsLinkBulkPathReplacementEditorAction {
    return {
        type: SAVE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR,
        massActionId,
        isSiteLinkEnabled,
        domains
    };
}

export const SHOW_ERROR_MASS_ACTIONS_ERROR_EDITOR =
    'SHOW_ERROR_MASS_ACTIONS_ERROR_EDITOR';
export type SHOW_ERROR_MASS_ACTIONS_ERROR_EDITOR = typeof SHOW_ERROR_MASS_ACTIONS_ERROR_EDITOR;
export interface ShowErrorMassActionsErrorEditorAction {
    type: SHOW_ERROR_MASS_ACTIONS_ERROR_EDITOR;
    errors: ErrorItem[];
    massActionId: MassActionId;
}

export function showErrorMassActionsErrorEditor(
    errors: ErrorItem[],
    massActionId: MassActionId
): ShowErrorMassActionsErrorEditorAction {
    return {
        type: SHOW_ERROR_MASS_ACTIONS_ERROR_EDITOR,
        errors,
        massActionId
    };
}

export const CLOSE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR =
    'CLOSE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR';
export type CLOSE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR = typeof CLOSE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR;
export interface CloseMassActionsLinkBulkReplacementEditorAction {
    type: CLOSE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function closeMassActionsLinkBulkReplacementEditor(
    massActionId: MassActionId
): CloseMassActionsLinkBulkReplacementEditorAction {
    return {
        type: CLOSE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const OPEN_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR =
    'OPEN_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR';
export type OPEN_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR = typeof OPEN_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR;

export interface OpenMassActionsBulkImageReplacementEditorAction {
    type: OPEN_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export const openMassActionsBulkImageReplacementEditor = (
    massActionId: MassActionId
): OpenMassActionsBulkImageReplacementEditorAction => {
    return {
        type: OPEN_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR,
        massActionId
    };
};

export const ACCEPT_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR =
    'ACCEPT_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR';
export type ACCEPT_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR = typeof ACCEPT_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR;

export interface AcceptMassActionsBulkImageCreativeReplacementEditor {
    type: ACCEPT_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export const acceptMassActionsBulkImageCreativeReplacementEditor = (
    massActionId: MassActionId
): AcceptMassActionsBulkImageCreativeReplacementEditor => {
    return {
        type: ACCEPT_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR,
        massActionId
    };
};

export const CLOSE_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR =
    'CLOSE_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR';
export type CLOSE_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR = typeof CLOSE_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR;

export interface CloseMassActionsBulkImageCreativeReplacementEditorAction {
    type: CLOSE_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export const closeMassActionsBulkImageCreativeReplacementEditor = (
    massActionId: MassActionId
): CloseMassActionsBulkImageCreativeReplacementEditorAction => {
    return {
        type: CLOSE_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR,
        massActionId
    };
};

export const OPEN_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR =
    'OPEN_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR';
export type OPEN_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR = typeof OPEN_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR;

export interface OpenMassActionsBulkImageCreativeReplacementEditorAction {
    type: OPEN_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export const openMassActionsBulkImageCreativeReplacementEditor = (
    massActionId: MassActionId
): OpenMassActionsBulkImageCreativeReplacementEditorAction => {
    return {
        type: OPEN_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR,
        massActionId
    };
};

export const OPEN_MASS_ACTIONS_BULK_CPM_IMAGE_CREATIVE_REPLACEMENT_EDITOR =
    'OPEN_MASS_ACTIONS_BULK_CPM_IMAGE_CREATIVE_REPLACEMENT_EDITOR';
export type OPEN_MASS_ACTIONS_BULK_CPM_IMAGE_CREATIVE_REPLACEMENT_EDITOR = typeof OPEN_MASS_ACTIONS_BULK_CPM_IMAGE_CREATIVE_REPLACEMENT_EDITOR;

export interface OpenMassActionsBulkCpmImageCreativeReplacementEditorAction {
    type: OPEN_MASS_ACTIONS_BULK_CPM_IMAGE_CREATIVE_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export const openMassActionsBulkCpmImageCreativeReplacementEditor = (
    massActionId: MassActionId
): OpenMassActionsBulkCpmImageCreativeReplacementEditorAction => {
    return {
        type: OPEN_MASS_ACTIONS_BULK_CPM_IMAGE_CREATIVE_REPLACEMENT_EDITOR,
        massActionId
    };
};

export const CLOSE_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR =
    'CLOSE_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR';
export type CLOSE_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR = typeof CLOSE_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR;

export interface CloseMassActionsBulkImageReplacementEditorAction {
    type: CLOSE_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export const closeMassActionsBulkImageReplacementEditor = (
    massActionId: MassActionId
): CloseMassActionsBulkImageReplacementEditorAction => {
    return {
        type: CLOSE_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR,
        massActionId
    };
};

export const ON_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR_TOGGLE_CHANGED =
    'ON_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR_TOGGLE_CHANGED';
export type ON_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR_TOGGLE_CHANGED = typeof ON_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR_TOGGLE_CHANGED;

export interface OnMassActionsBulkImageReplacementEditorToggleChangedAction {
    type: ON_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR_TOGGLE_CHANGED;
    massActionId: MassActionId;
    toggleValue: BulkReplacementRadio;
}

export const onMassActionsBulkImageReplacementEditorToggleChanged = (
    massActionId: MassActionId,
    toggleValue: BulkReplacementRadio
): OnMassActionsBulkImageReplacementEditorToggleChangedAction => {
    return {
        type: ON_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR_TOGGLE_CHANGED,
        massActionId,
        toggleValue
    };
};

export const OPEN_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR =
    'OPEN_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR';
export type OPEN_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR = typeof OPEN_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR;
export interface OpenMassActionsTextBulkReplacementEditorAction {
    type: OPEN_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function openMassActionsTextBulkReplacementEditor(
    massActionId: MassActionId
): OpenMassActionsTextBulkReplacementEditorAction {
    return {
        type: OPEN_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const CLOSE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR =
    'CLOSE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR';
export type CLOSE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR = typeof CLOSE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR;
export interface CloseMassActionsTextBulkReplacementEditorAction {
    type: CLOSE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function closeMassActionsTextBulkReplacementEditor(
    massActionId: MassActionId
): CloseMassActionsTextBulkReplacementEditorAction {
    return {
        type: CLOSE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ON_SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR =
    'ON_SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR';
export type ON_SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR = typeof ON_SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR;
export interface OnSaveMassActionsTextBulkReplacementEditorAction {
    type: ON_SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function onSaveMassActionsTextBulkReplacementEditor(
    massActionId: MassActionId
): OnSaveMassActionsTextBulkReplacementEditorAction {
    return {
        type: ON_SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR =
    'SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR';
export type SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR = typeof SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR;
export interface SaveMassActionsTextBulkReplacementEditorAction {
    type: SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function saveMassActionsTextBulkReplacementEditor(
    massActionId: MassActionId
): SaveMassActionsTextBulkReplacementEditorAction {
    return {
        type: SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const CHANGE_MASS_ACTIONS_TEXT_BULK_TITLE_TUMBLER =
    'CHANGE_MASS_ACTIONS_TEXT_BULK_TITLE_TUMBLER';
export type CHANGE_MASS_ACTIONS_TEXT_BULK_TITLE_TUMBLER = typeof CHANGE_MASS_ACTIONS_TEXT_BULK_TITLE_TUMBLER;
export interface ChangeMassActionsTextBulkTitleTumblerAction {
    type: CHANGE_MASS_ACTIONS_TEXT_BULK_TITLE_TUMBLER;
    massActionId: MassActionId;
}

export function changeMassActionsTextBulkTitleTumbler(
    massActionId: MassActionId
): ChangeMassActionsTextBulkTitleTumblerAction {
    return {
        type: CHANGE_MASS_ACTIONS_TEXT_BULK_TITLE_TUMBLER,
        massActionId
    };
}

export const CHANGE_MASS_ACTIONS_TEXT_BULK_ADDITIONAL_TEXT_TUMBLER =
    'CHANGE_MASS_ACTIONS_TEXT_BULK_ADDITIONAL_TEXT_TUMBLER';
export type CHANGE_MASS_ACTIONS_TEXT_BULK_ADDITIONAL_TEXT_TUMBLER = typeof CHANGE_MASS_ACTIONS_TEXT_BULK_ADDITIONAL_TEXT_TUMBLER;
export interface ChangeMassActionsTextBulkAdditionalTextTumblerAction {
    type: CHANGE_MASS_ACTIONS_TEXT_BULK_ADDITIONAL_TEXT_TUMBLER;
    massActionId: MassActionId;
}

export function changeMassActionsTextBulkAdditionalTextTumbler(
    massActionId: MassActionId
): ChangeMassActionsTextBulkAdditionalTextTumblerAction {
    return {
        type: CHANGE_MASS_ACTIONS_TEXT_BULK_ADDITIONAL_TEXT_TUMBLER,
        massActionId
    };
}

export const CHANGE_MASS_ACTIONS_TEXT_BULK_SITE_LINKS_TUMBLER =
    'CHANGE_MASS_ACTIONS_TEXT_BULK_SITE_LINKS_TUMBLER';
export type CHANGE_MASS_ACTIONS_TEXT_BULK_SITE_LINKS_TUMBLER = typeof CHANGE_MASS_ACTIONS_TEXT_BULK_SITE_LINKS_TUMBLER;
export interface ChangeMassActionsTextBulkSiteLinkTumblerAction {
    type: CHANGE_MASS_ACTIONS_TEXT_BULK_SITE_LINKS_TUMBLER;
    massActionId: MassActionId;
}

export function changeMassActionsTextBulkSiteLinkTumbler(
    massActionId: MassActionId
): ChangeMassActionsTextBulkSiteLinkTumblerAction {
    return {
        type: CHANGE_MASS_ACTIONS_TEXT_BULK_SITE_LINKS_TUMBLER,
        massActionId
    };
}

export const CHANGE_MASS_ACTIONS_TEXT_BULK_RADIO =
    'CHANGE_MASS_ACTIONS_TEXT_BULK_RADIO';
export type CHANGE_MASS_ACTIONS_TEXT_BULK_RADIO = typeof CHANGE_MASS_ACTIONS_TEXT_BULK_RADIO;
export interface ChangeMassActionsTextBulkRadioAction {
    type: CHANGE_MASS_ACTIONS_TEXT_BULK_RADIO;
    massActionId: MassActionId;
    value: BulkReplacementRadio;
}

export function changeMassActionsTextBulkRadio(
    massActionId: MassActionId,
    value: BulkReplacementRadio
): ChangeMassActionsTextBulkRadioAction {
    return {
        type: CHANGE_MASS_ACTIONS_TEXT_BULK_RADIO,
        massActionId,
        value
    };
}

export const CHANGE_MASS_ACTIONS_TEXT_BULK_NEW_TEXT =
    'CHANGE_MASS_ACTIONS_TEXT_BULK_NEW_TEXT';
export type CHANGE_MASS_ACTIONS_TEXT_BULK_NEW_TEXT = typeof CHANGE_MASS_ACTIONS_TEXT_BULK_NEW_TEXT;
export interface ChangeMassActionsTextBulkTextAction {
    type: CHANGE_MASS_ACTIONS_TEXT_BULK_NEW_TEXT;
    massActionId: MassActionId;
    newText: string;
}

export function changeMassActionsTextBulkText(
    massActionId: MassActionId,
    newText: string
): ChangeMassActionsTextBulkTextAction {
    return {
        type: CHANGE_MASS_ACTIONS_TEXT_BULK_NEW_TEXT,
        massActionId,
        newText
    };
}

export const ON_MASS_ACTIONS_TEXT_BULK_SOURCE_TEXT_CHANGE =
    'ON_MASS_ACTIONS_TEXT_BULK_SOURCE_TEXT_CHANGE';
export type ON_MASS_ACTIONS_TEXT_BULK_SOURCE_TEXT_CHANGE = typeof ON_MASS_ACTIONS_TEXT_BULK_SOURCE_TEXT_CHANGE;
export interface ChangeMassActionsTextBulkTextItemsAction {
    type: ON_MASS_ACTIONS_TEXT_BULK_SOURCE_TEXT_CHANGE;
    massActionId: MassActionId;
    text: string;
}

export function onMassActionsTextBulkSourceTextChange(
    massActionId: MassActionId,
    text: string
): ChangeMassActionsTextBulkTextItemsAction {
    return {
        type: ON_MASS_ACTIONS_TEXT_BULK_SOURCE_TEXT_CHANGE,
        massActionId,
        text
    };
}

export const OPEN_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR =
    'OPEN_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR';
export type OPEN_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR = typeof OPEN_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR;
export interface OpenMassActionsLinkDisplayedBulkReplacementEditorAction {
    type: OPEN_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function openMassActionsLinkDisplayedBulkReplacementEditor(
    massActionId: MassActionId
): OpenMassActionsLinkDisplayedBulkReplacementEditorAction {
    return {
        type: OPEN_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const CLOSE_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR =
    'CLOSE_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR';
export type CLOSE_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR = typeof CLOSE_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR;
export interface CloseMassActionsLinkDisplayedBulkReplacementEditorAction {
    type: CLOSE_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function closeMassActionsLinkDisplayedBulkReplacementEditor(
    massActionId: MassActionId
): CloseMassActionsLinkDisplayedBulkReplacementEditorAction {
    return {
        type: CLOSE_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR =
    'ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR';
export type ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR = typeof ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR;
export interface AcceptMassActionsLinkDisplayedBulkReplacementEditorAction {
    type: ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function acceptMassActionsLinkDisplayedBulkReplacementEditor(
    massActionId: MassActionId
): AcceptMassActionsLinkDisplayedBulkReplacementEditorAction {
    return {
        type: ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ON_ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR =
    'ON_ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR';
export type ON_ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR = typeof ON_ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR;
export interface OnAcceptMassActionsLinkDisplayedBulkReplacementEditorAction {
    type: ON_ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function onAcceptMassActionsLinkDisplayedBulkReplacementEditor(
    massActionId: MassActionId
): OnAcceptMassActionsLinkDisplayedBulkReplacementEditorAction {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const CHANGE_LINK_DISPLAYED_BULK_EDITOR_NEW_URL =
    'CHANGE_LINK_DISPLAYED_BULK_EDITOR_NEW_URL';
export type CHANGE_LINK_DISPLAYED_BULK_EDITOR_NEW_URL = typeof CHANGE_LINK_DISPLAYED_BULK_EDITOR_NEW_URL;
export interface ChangeLinkDisplayedBulkEditorNewUrlAction {
    type: CHANGE_LINK_DISPLAYED_BULK_EDITOR_NEW_URL;
    newVisibleLink: string;
    massActionId: MassActionId;
}

export function changeLinkDisplayedBulkEditorNewUrl(
    newUrl: string,
    massActionId: MassActionId
): ChangeLinkDisplayedBulkEditorNewUrlAction {
    return {
        type: CHANGE_LINK_DISPLAYED_BULK_EDITOR_NEW_URL,
        newVisibleLink: newUrl,
        massActionId
    };
}

export const CHANGE_LINK_DISPLAYED_BULK_EDITOR_SELECTED_LINK =
    'CHANGE_LINK_DISPLAYED_BULK_EDITOR_SELECTED_LINK';
export type CHANGE_LINK_DISPLAYED_BULK_EDITOR_SELECTED_LINK = typeof CHANGE_LINK_DISPLAYED_BULK_EDITOR_SELECTED_LINK;
export interface ChangeLinkDisplayedBulkEditorSelectedLinkAction {
    type: CHANGE_LINK_DISPLAYED_BULK_EDITOR_SELECTED_LINK;
    selectedSourceItems: string;
    massActionId: MassActionId;
}

export function changeLinkDisplayedBulkEditorSelectedLink(
    selectedSourceUrls: string,
    massActionId: MassActionId
): ChangeLinkDisplayedBulkEditorSelectedLinkAction {
    return {
        type: CHANGE_LINK_DISPLAYED_BULK_EDITOR_SELECTED_LINK,
        selectedSourceItems: selectedSourceUrls,
        massActionId
    };
}

export const ON_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED =
    'ON_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED';
export type ON_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED = typeof ON_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED;
export interface OnMassActionsLinkDisplayedBulkReplacementEditorRadioButtonStateChangedAction {
    type: ON_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED;
    massActionId: MassActionId;
    value: BulkReplacementRadio;
}

export function onMassActionsLinkDisplayedBulkReplacementEditorRadioButtonStateChanged(
    massActionId: MassActionId,
    value: BulkReplacementRadio
): OnMassActionsLinkDisplayedBulkReplacementEditorRadioButtonStateChangedAction {
    return {
        type: ON_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED,
        massActionId,
        value
    };
}

export const UPDATE_MASS_ACTIONS_IMAGE_CREATIVE =
    'UPDATE_MASS_ACTIONS_IMAGE_CREATIVE';
export type UPDATE_MASS_ACTIONS_IMAGE_CREATIVE = typeof UPDATE_MASS_ACTIONS_IMAGE_CREATIVE;
export interface UpdateMassActionsImageCreativeAction {
    type: UPDATE_MASS_ACTIONS_IMAGE_CREATIVE;
    massActionId: MassActionId;
    creative: BannerImageForEdit[];
}

export function updateMassActionsImageCreative(
    massActionId: MassActionId,
    creative: BannerImageForEdit[]
): UpdateMassActionsImageCreativeAction {
    return {
        type: UPDATE_MASS_ACTIONS_IMAGE_CREATIVE,
        massActionId,
        creative
    };
}

export const ON_ACCEPT_MASS_ACTIONS_IMAGE = 'ON_ACCEPT_MASS_ACTIONS_IMAGE';
export type ON_ACCEPT_MASS_ACTIONS_IMAGE = typeof ON_ACCEPT_MASS_ACTIONS_IMAGE;

export interface OnAcceptMassActionsImageAction {
    type: ON_ACCEPT_MASS_ACTIONS_IMAGE;
    massActionId: MassActionId;
}

export function onAcceptMassActionsImage(
    massActionId: MassActionId
): OnAcceptMassActionsImageAction {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_IMAGE,
        massActionId
    };
}

export const OPEN_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR =
    'OPEN_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR';
export type OPEN_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR = typeof OPEN_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR;
export interface OpenMassActionsVideoBulkReplacementEditorAction {
    type: OPEN_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function openMassActionsVideoBulkReplacementEditorAction(
    massActionId: MassActionId
): OpenMassActionsVideoBulkReplacementEditorAction {
    return {
        type: OPEN_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const CLOSE_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR =
    'CLOSE_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR';
export type CLOSE_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR = typeof CLOSE_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR;
export interface CloseMassActionsVideoBulkReplacementEditor {
    type: CLOSE_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function closeMassActionsVideoBulkReplacementEditor(
    massActionId: MassActionId
): CloseMassActionsVideoBulkReplacementEditor {
    return {
        type: CLOSE_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ON_ACCEPT_MASS_ACTIONS_VIDEO = 'ON_ACCEPT_MASS_ACTIONS_VIDEO';
export type ON_ACCEPT_MASS_ACTIONS_VIDEO = typeof ON_ACCEPT_MASS_ACTIONS_VIDEO;

export interface OnAcceptMassActionsVideoAction {
    type: ON_ACCEPT_MASS_ACTIONS_VIDEO;
    massActionId: MassActionId;
}

export function onAcceptMassActionsVideoAction(
    massActionId: MassActionId
): OnAcceptMassActionsVideoAction {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_VIDEO,
        massActionId
    };
}

export const ON_ACCEPT_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR =
    'ON_ACCEPT_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR';
export type ON_ACCEPT_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR = typeof ON_ACCEPT_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR;
export interface OnAcceptMassActionsVideoBulkReplacementEditor {
    type: ON_ACCEPT_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function onAcceptMassActionsVideoBulkReplacementEditor(
    massActionId: MassActionId
): OnAcceptMassActionsVideoBulkReplacementEditor {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ON_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED =
    'ON_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED';
export type ON_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED = typeof ON_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED;
export interface OnMassActionsVideoBulkReplacementEditorRadioButtonStateChanged {
    type: ON_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED;
    massActionId: MassActionId;
    value: BulkReplacementRadio;
}

export function onMassActionsVideoBulkReplacementEditorRadioButtonStateChanged(
    massActionId: MassActionId,
    value: BulkReplacementRadio
): OnMassActionsVideoBulkReplacementEditorRadioButtonStateChanged {
    return {
        type: ON_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED,
        massActionId,
        value
    };
}

export const OPEN_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR =
    'OPEN_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR';
export type OPEN_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR = typeof OPEN_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR;
export interface OpenMassActionsVideoCreativeBulkReplacementEditorAction {
    type: OPEN_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
    bannerType: AdvType;
}

export function openMassActionsVideoCreativeBulkReplacementEditorAction(
    massActionId: MassActionId,
    bannerType: AdvType
): OpenMassActionsVideoCreativeBulkReplacementEditorAction {
    return {
        type: OPEN_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR,
        massActionId,
        bannerType
    };
}

export const CLOSE_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR =
    'CLOSE_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR';
export type CLOSE_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR = typeof CLOSE_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR;
export interface CloseMassActionsVideoCreativeBulkReplacementEditor {
    type: CLOSE_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function closeMassActionsVideoCreativeBulkReplacementEditor(
    massActionId: MassActionId
): CloseMassActionsVideoCreativeBulkReplacementEditor {
    return {
        type: CLOSE_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const CLOSE_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR =
    'CLOSE_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR';
export type CLOSE_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR = typeof CLOSE_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR;
export interface CloseMassActionsCpmCreativeBulkReplacementEditor {
    type: CLOSE_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function closeMassActionsCpmCreativeBulkReplacementEditor(
    massActionId: MassActionId
): CloseMassActionsCpmCreativeBulkReplacementEditor {
    return {
        type: CLOSE_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ON_ACCEPT_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR =
    'ON_ACCEPT_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR';
export type ON_ACCEPT_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR = typeof ON_ACCEPT_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR;
export interface OnAcceptMassActionsCpmCreativeBulkReplacementEditor {
    type: ON_ACCEPT_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function onAcceptMassActionsCpmCreativeBulkReplacementEditor(
    massActionId: MassActionId
): OnAcceptMassActionsCpmCreativeBulkReplacementEditor {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const CLOSE_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR =
    'CLOSE_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR';
export type CLOSE_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR = typeof CLOSE_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR;
export interface CloseMassActionsPixelBulkReplacementEditor {
    type: CLOSE_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function closeMassActionsPixelBulkReplacementEditor(
    massActionId: MassActionId
): CloseMassActionsPixelBulkReplacementEditor {
    return {
        type: CLOSE_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ON_ACCEPT_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR =
    'ON_ACCEPT_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR';
export type ON_ACCEPT_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR = typeof ON_ACCEPT_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR;
export interface OnAcceptMassActionsPixelBulkReplacementEditor {
    type: ON_ACCEPT_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function onAcceptMassActionsPixelBulkReplacementEditor(
    massActionId: MassActionId
): OnAcceptMassActionsPixelBulkReplacementEditor {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ON_ACCEPT_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR =
    'ON_ACCEPT_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR';
export type ON_ACCEPT_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR = typeof ON_ACCEPT_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR;
export interface OnAcceptMassActionsVideoCreativeBulkReplacementEditor {
    type: ON_ACCEPT_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function onAcceptMassActionsVideoCreativeBulkReplacementEditor(
    massActionId: MassActionId
): OnAcceptMassActionsVideoCreativeBulkReplacementEditor {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ON_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED =
    'ON_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED';
export type ON_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED = typeof ON_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED;
export interface OnMassActionsVideoCreativeBulkReplacementEditorRadioButtonStateChanged {
    type: ON_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED;
    massActionId: MassActionId;
    value: BulkReplacementRadio;
}

export function onMassActionsVideoCreativeBulkReplacementEditorRadioButtonStateChanged(
    massActionId: MassActionId,
    value: BulkReplacementRadio
): OnMassActionsVideoCreativeBulkReplacementEditorRadioButtonStateChanged {
    return {
        type: ON_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED,
        massActionId,
        value
    };
}

export const ON_OPEN_MASS_ACTIONS_SITE_LINKS_EDITOR =
    'ON_OPEN_MASS_ACTIONS_SITE_LINKS_EDITOR';
export type ON_OPEN_MASS_ACTIONS_SITE_LINKS_EDITOR = typeof ON_OPEN_MASS_ACTIONS_SITE_LINKS_EDITOR;
export interface OnOpenMassActionsSiteLinksEditorAction {
    type: ON_OPEN_MASS_ACTIONS_SITE_LINKS_EDITOR;
    massActionId: MassActionId;
}

export function onOpenMassActionsSiteLinksEditor(
    massActionId: MassActionId
): OnOpenMassActionsSiteLinksEditorAction {
    return {
        type: ON_OPEN_MASS_ACTIONS_SITE_LINKS_EDITOR,
        massActionId
    };
}

export const CLOSE_MASS_ACTIONS_SITE_LINKS_EDITOR =
    'CLOSE_MASS_ACTIONS_SITE_LINKS_EDITOR';
export type CLOSE_MASS_ACTIONS_SITE_LINKS_EDITOR = typeof CLOSE_MASS_ACTIONS_SITE_LINKS_EDITOR;
export interface CloseMassActionsSiteLinksEditorAction {
    type: CLOSE_MASS_ACTIONS_SITE_LINKS_EDITOR;
    massActionId: MassActionId;
}

export function closeMassActionsSiteLinksEditor(
    massActionId: MassActionId
): CloseMassActionsSiteLinksEditorAction {
    return {
        type: CLOSE_MASS_ACTIONS_SITE_LINKS_EDITOR,
        massActionId
    };
}

export const ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR =
    'ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR';
export type ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR = typeof ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR;
export interface AcceptMassActionsSiteLinksEditorAction {
    type: ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR;
    massActionId: MassActionId;
}

export function acceptMassActionsSiteLinksEditor(
    massActionId: MassActionId
): AcceptMassActionsSiteLinksEditorAction {
    return {
        type: ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR,
        massActionId
    };
}

export const ON_ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR =
    'ON_ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR';
export type ON_ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR = typeof ON_ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR;
export interface OnAcceptMassActionsSiteLinksEditorAction {
    type: ON_ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR;
    massActionId: MassActionId;
}

export function onAcceptMassActionsSiteLinksEditor(
    massActionId: MassActionId
): OnAcceptMassActionsSiteLinksEditorAction {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR,
        massActionId
    };
}

export const CHANGE_MASS_ACTIONS_SITE_LINKS_RADIO =
    'CHANGE_MASS_ACTIONS_SITE_LINKS_RADIO';
export type CHANGE_MASS_ACTIONS_SITE_LINKS_RADIO = typeof CHANGE_MASS_ACTIONS_SITE_LINKS_RADIO;
export interface ChangeMassActionsSiteLinksRadio {
    type: CHANGE_MASS_ACTIONS_SITE_LINKS_RADIO;
    massActionId: MassActionId;
    value: BulkReplacementRadio;
}

export function changeMassActionsSiteLinksRadio(
    massActionId: MassActionId,
    value: BulkReplacementRadio
): ChangeMassActionsSiteLinksRadio {
    return {
        type: CHANGE_MASS_ACTIONS_SITE_LINKS_RADIO,
        massActionId,
        value
    };
}

export const ON_ACCEPT_MASS_ACTIONS_BANNERS_PRICE =
    'ON_ACCEPT_MASS_ACTIONS_BANNERS_PRICE';
export type ON_ACCEPT_MASS_ACTIONS_BANNERS_PRICE = typeof ON_ACCEPT_MASS_ACTIONS_BANNERS_PRICE;
export interface AcceptMassActionsBannersPrice {
    type: ON_ACCEPT_MASS_ACTIONS_BANNERS_PRICE;
    massActionId: MassActionId;
    bannerId: EditorBannerPriceId;
}

export function acceptMassActionsBannersPrice(
    massActionId: MassActionId,
    bannerId: EditorBannerPriceId
): AcceptMassActionsBannersPrice {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_BANNERS_PRICE,
        massActionId,
        bannerId
    };
}

export const CLOSE_MASS_ACTIONS_BANNERS_PRICE =
    'CLOSE_MASS_ACTIONS_BANNERS_PRICE';
export type CLOSE_MASS_ACTIONS_BANNERS_PRICE = typeof CLOSE_MASS_ACTIONS_BANNERS_PRICE;
export interface CloseMassActionsBannersPrice {
    type: CLOSE_MASS_ACTIONS_BANNERS_PRICE;
    massActionId: MassActionId;
}

export function closeMassActionsBannersPrice(
    massActionId: MassActionId
): CloseMassActionsBannersPrice {
    return {
        type: CLOSE_MASS_ACTIONS_BANNERS_PRICE,
        massActionId
    };
}

export const OPEN_MASS_ACTIONS_BANNERS_PRICE =
    'OPEN_MASS_ACTIONS_BANNERS_PRICE';
export type OPEN_MASS_ACTIONS_BANNERS_PRICE = typeof OPEN_MASS_ACTIONS_BANNERS_PRICE;
export interface OpenMassActionsBannersPrice {
    type: OPEN_MASS_ACTIONS_BANNERS_PRICE;
    massActionId: MassActionId;
    bannerId: EditorBannerPriceId;
}

export function openMassActionsBannersPrice(
    massActionId: MassActionId,
    bannerId: EditorBannerPriceId
): OpenMassActionsBannersPrice {
    return {
        type: OPEN_MASS_ACTIONS_BANNERS_PRICE,
        massActionId,
        bannerId
    };
}

export const OPEN_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR =
    'OPEN_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR';
export type OPEN_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR = typeof OPEN_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR;
export interface OpenMassActionsTurbolandingBulkReplacementEditorAction {
    type: OPEN_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function openMassActionsTurbolandingBulkReplacementEditorAction(
    massActionId: MassActionId
): OpenMassActionsTurbolandingBulkReplacementEditorAction {
    return {
        type: OPEN_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const CLOSE_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR =
    'CLOSE_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR';
export type CLOSE_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR = typeof CLOSE_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR;
export interface CloseMassActionsTurbolandingBulkReplacementEditor {
    type: CLOSE_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function closeMassActionsTurbolandingBulkReplacementEditor(
    massActionId: MassActionId
): CloseMassActionsTurbolandingBulkReplacementEditor {
    return {
        type: CLOSE_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ON_ACCEPT_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR =
    'ON_ACCEPT_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR';
export type ON_ACCEPT_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR = typeof ON_ACCEPT_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR;
export interface OnAcceptMassActionsTurbolandingBulkReplacementEditor {
    type: ON_ACCEPT_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function onAcceptMassActionsTurbolandingBulkReplacementEditor(
    massActionId: MassActionId
): OnAcceptMassActionsTurbolandingBulkReplacementEditor {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ON_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED =
    'ON_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED';
export type ON_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED = typeof ON_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED;
export interface OnMassActionsTurbolandingBulkReplacementEditorRadioButtonStateChanged {
    type: ON_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED;
    massActionId: MassActionId;
    value: BulkReplacementRadio;
}

export function onMassActionsTurbolandingBulkReplacementEditorRadioButtonStateChanged(
    massActionId: MassActionId,
    value: BulkReplacementRadio
): OnMassActionsTurbolandingBulkReplacementEditorRadioButtonStateChanged {
    return {
        type: ON_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED,
        massActionId,
        value
    };
}

export const OPEN_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR =
    'OPEN_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR';
export type OPEN_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR = typeof OPEN_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR;

export interface OpenMassActionsTrackingParametersBulkReplacementEditorAction {
    type: OPEN_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function openMassActionsTrackingParametersBulkReplacementEditor(
    massActionId: MassActionId
): OpenMassActionsTrackingParametersBulkReplacementEditorAction {
    return {
        type: OPEN_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const CLOSE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR =
    'CLOSE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR';
export type CLOSE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR = typeof CLOSE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR;

export interface CloseMassActionsTrackingParametersBulkReplacementEditorAction {
    type: CLOSE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function closeMassActionsTrackingParametersBulkReplacementEditor(
    massActionId: MassActionId
): CloseMassActionsTrackingParametersBulkReplacementEditorAction {
    return {
        type: CLOSE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ON_ACCEPT_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR =
    'ON_ACCEPT_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR';
export type ON_ACCEPT_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR = typeof ON_ACCEPT_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR;

export interface OnAcceptMassActionsTrackingParametersBulkReplacementEditorAction {
    type: ON_ACCEPT_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function onAcceptMassActionsTrackingParametersBulkReplacementEditor(
    massActionId: MassActionId
): OnAcceptMassActionsTrackingParametersBulkReplacementEditorAction {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_SITE_LINKS_TUMBLER =
    'CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_SITE_LINKS_TUMBLER';
export type CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_SITE_LINKS_TUMBLER = typeof CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_SITE_LINKS_TUMBLER;

export interface ChangeMassActionsTrackingParametersBulkSiteLinksTumblerAction {
    type: CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_SITE_LINKS_TUMBLER;
    massActionId: MassActionId;
}

export function changeMassActionsTrackingParametersBulkSiteLinksTumbler(
    massActionId: MassActionId
): ChangeMassActionsTrackingParametersBulkSiteLinksTumblerAction {
    return {
        type: CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_SITE_LINKS_TUMBLER,
        massActionId
    };
}

export const CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_KEY_OR_VALUE_SELECT =
    'CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_KEY_OR_VALUE_SELECT';
export type CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_KEY_OR_VALUE_SELECT = typeof CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_KEY_OR_VALUE_SELECT;

export interface ChangeMassActionsTrackingParametersBulkKeyOrValueSelectAction {
    type: CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_KEY_OR_VALUE_SELECT;
    massActionId: MassActionId;
    keyOrValueReplacement: TrackingParametersReplacementSelect;
}

export const changeMassActionsTrackingParametersBulkKeyOrValueSelect = (
    massActionId: MassActionId,
    keyOrValueReplacement: TrackingParametersReplacementSelect
): ChangeMassActionsTrackingParametersBulkKeyOrValueSelectAction => {
    return {
        type: CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_KEY_OR_VALUE_SELECT,
        massActionId,
        keyOrValueReplacement
    };
};

export const CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_TARGET_PARAMETERS =
    'CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_TARGET_PARAMETERS';
export type CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_TARGET_PARAMETERS = typeof CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_TARGET_PARAMETERS;

export interface ChangeMassActionsTrackingParametersBulkTargetParametersAction {
    type: CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_TARGET_PARAMETERS;
    massActionId: MassActionId;
    targetParameters: string;
}

export function changeMassActionsTrackingParametersBulkTargetParameters(
    massActionId: MassActionId,
    targetParameters: string
): ChangeMassActionsTrackingParametersBulkTargetParametersAction {
    return {
        type: CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_TARGET_PARAMETERS,
        massActionId,
        targetParameters
    };
}

export const CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_NEW_PARAMETERS =
    'CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_NEW_PARAMETERS';
export type CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_NEW_PARAMETERS = typeof CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_NEW_PARAMETERS;

export interface ChangeMassActionsTrackingParametersBulkNewParametersAction {
    type: CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_NEW_PARAMETERS;
    massActionId: MassActionId;
    newParameters: string;
}

export function changeMassActionsTrackingParametersBulkNewParameters(
    massActionId: MassActionId,
    newParameters: string
): ChangeMassActionsTrackingParametersBulkNewParametersAction {
    return {
        type: CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_NEW_PARAMETERS,
        massActionId,
        newParameters
    };
}

export const ON_OPEN_MASS_ACTIONS_PIXEL = 'ON_OPEN_MASS_ACTIONS_PIXEL';
export type ON_OPEN_MASS_ACTIONS_PIXEL = typeof ON_OPEN_MASS_ACTIONS_PIXEL;

export interface OnOpenMassActionsPixelAction {
    type: ON_OPEN_MASS_ACTIONS_PIXEL;
    massActionId: MassActionId;
}

export function openMassActionsPixel(
    massActionId: MassActionId
): OnOpenMassActionsPixelAction {
    return {
        type: ON_OPEN_MASS_ACTIONS_PIXEL,
        massActionId
    };
}

export const ON_OPEN_MASS_ACTIONS_COUNTERS = 'ON_OPEN_MASS_ACTIONS_COUNTERS';
export type ON_OPEN_MASS_ACTIONS_COUNTERS = typeof ON_OPEN_MASS_ACTIONS_COUNTERS;

export interface OnOpenMassActionsCountersAction {
    type: ON_OPEN_MASS_ACTIONS_COUNTERS;
    massActionId: MassActionId;
}

export function openMassActionsCounters(
    massActionId: MassActionId
): OnOpenMassActionsCountersAction {
    return {
        type: ON_OPEN_MASS_ACTIONS_COUNTERS,
        massActionId
    };
}

export const CLOSE_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR =
    'CLOSE_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR';
export type CLOSE_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR = typeof CLOSE_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR;
export interface CloseMassActionsCountersBulkReplacementEditor {
    type: CLOSE_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function closeMassActionsCountersBulkReplacementEditor(
    massActionId: MassActionId
): CloseMassActionsCountersBulkReplacementEditor {
    return {
        type: CLOSE_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ON_ACCEPT_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR =
    'ON_ACCEPT_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR';
export type ON_ACCEPT_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR = typeof ON_ACCEPT_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR;
export interface OnAcceptMassActionsCountersBulkReplacementEditor {
    type: ON_ACCEPT_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR;
    massActionId: MassActionId;
}

export function onAcceptMassActionsCountersBulkReplacementEditor(
    massActionId: MassActionId
): OnAcceptMassActionsCountersBulkReplacementEditor {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR,
        massActionId
    };
}

export const ON_OPEN_MASS_ACTIONS_CALLOUTS = 'ON_OPEN_MASS_ACTIONS_CALLOUTS';
export type ON_OPEN_MASS_ACTIONS_CALLOUTS = typeof ON_OPEN_MASS_ACTIONS_CALLOUTS;

export interface OnOpenMassActionsCalloutsAction {
    type: ON_OPEN_MASS_ACTIONS_CALLOUTS;
    massActionId: MassActionId;
}

export function openMassActionsCallouts(
    massActionId: MassActionId
): OnOpenMassActionsCalloutsAction {
    return {
        type: ON_OPEN_MASS_ACTIONS_CALLOUTS,
        massActionId
    };
}

export const CLOSE_MASS_ACTIONS_CALLOUTS = 'CLOSE_MASS_ACTIONS_CALLOUTS';
export type CLOSE_MASS_ACTIONS_CALLOUTS = typeof CLOSE_MASS_ACTIONS_CALLOUTS;

export interface CloseMassActionsCalloutsAction {
    type: CLOSE_MASS_ACTIONS_CALLOUTS;
    massActionId: MassActionId;
}

export function onCloseMassActionsCallouts(
    massActionId: MassActionId
): CloseMassActionsCalloutsAction {
    return {
        type: CLOSE_MASS_ACTIONS_CALLOUTS,
        massActionId
    };
}

export const CHANGE_MASS_ACTIONS_CALLOUTS_RADIO_STATE =
    'CHANGE_MASS_ACTIONS_CALLOUTS_RADIO_STATE';
export type CHANGE_MASS_ACTIONS_CALLOUTS_RADIO_STATE = typeof CHANGE_MASS_ACTIONS_CALLOUTS_RADIO_STATE;

export interface ChangeMassActionsCalloutsRadioState {
    type: CHANGE_MASS_ACTIONS_CALLOUTS_RADIO_STATE;
    massActionId: MassActionId;
    value: BulkReplacementRadio;
}

export function changeMassActionsCalloutsRadioState(
    massActionId: MassActionId,
    value: BulkReplacementRadio
): ChangeMassActionsCalloutsRadioState {
    return {
        type: CHANGE_MASS_ACTIONS_CALLOUTS_RADIO_STATE,
        massActionId,
        value
    };
}

export const ACCEPT_MASS_ACTIONS_CALLOUTS = 'ACCEPT_MASS_ACTIONS_CALLOUTS';
export type ACCEPT_MASS_ACTIONS_CALLOUTS = typeof ACCEPT_MASS_ACTIONS_CALLOUTS;

export interface AcceptMassActionsCalloutsAction {
    type: ACCEPT_MASS_ACTIONS_CALLOUTS;
    massActionId: MassActionId;
}

export function acceptMassActionsCallouts(
    massActionId: MassActionId
): AcceptMassActionsCalloutsAction {
    return {
        type: ACCEPT_MASS_ACTIONS_CALLOUTS,
        massActionId
    };
}

export const ON_ACCEPT_MASS_ACTIONS_CALLOUTS =
    'ON_ACCEPT_MASS_ACTIONS_CALLOUTS';
export type ON_ACCEPT_MASS_ACTIONS_CALLOUTS = typeof ON_ACCEPT_MASS_ACTIONS_CALLOUTS;

export interface OnAcceptMassActionsCalloutsAction {
    type: ON_ACCEPT_MASS_ACTIONS_CALLOUTS;
    massActionId: MassActionId;
}

export function onAcceptMassActionsCallouts(
    massActionId: MassActionId
): OnAcceptMassActionsCalloutsAction {
    return {
        type: ON_ACCEPT_MASS_ACTIONS_CALLOUTS,
        massActionId
    };
}

export type BannersEditMassActions =
    | OnOpenMassActionsPixelAction
    | CloseMassActionsLinkBulkReplacementEditorAction
    | ChangeLinkBulkEditorSelectedLinkAction
    | CloseMassActionsBulkImageCreativeReplacementEditorAction
    | ChangeLinkBulkEditorProtocolLinkAction
    | CloseMassActionsCalloutsAction
    | AcceptMassActionsCalloutsAction
    | ChangeLinkBulkEditorNewLinkAction
    | OpenMassActionsBannersPrice
    | CloseMassActionsBannersPrice
    | AcceptMassActionsBannersPrice
    | ShowErrorMassActionsErrorEditorAction
    | OpenMassActionsLinkBulkPathReplacementEditorAction
    | CloseMassActionsLinkBulkPathReplacementEditorAction
    | SaveMassActionsLinkBulkReplacementEditorAction
    | SaveMassActionsLinkBulkPathReplacementEditorAction
    | OnMassActionsLinkBulkReplacementEditorTumblerChangedAction
    | ChangeMassActionsLinkBulkPathReplacementTargetPartUrlEditorAction
    | ChangeMassActionsLinkBulkPathReplacementNewPartUrlEditorAction
    | ChangeMassActionsLinkBulkPathReplacementDomainTumblerEditorAction
    | ChangeMassActionsLinkBulkPathReplacementParameterTumblerEditorAction
    | ChangeMassActionsLinkBulkPathReplacementSiteLinksTumblerEditorAction
    | OnAcceptMassActionsLinkBulkPathReplacementEditorAction
    | OnAcceptMassActionsLinkBulkReplacementEditorAction
    | OpenMassActionsLinkBulkReplacementEditorAction
    | OpenMassActionsBulkImageReplacementEditorAction
    | CloseMassActionsBulkImageReplacementEditorAction
    | OnMassActionsBulkImageReplacementEditorToggleChangedAction
    | OnAcceptBulkImageReplacementAction
    | OpenMassActionsTextBulkReplacementEditorAction
    | CloseMassActionsTextBulkReplacementEditorAction
    | ChangeMassActionsTextBulkAdditionalTextTumblerAction
    | ChangeMassActionsTextBulkSiteLinkTumblerAction
    | ChangeMassActionsTextBulkRadioAction
    | OnOpenMassActionsCalloutsAction
    | ChangeMassActionsTextBulkTextAction
    | SaveMassActionsTextBulkReplacementEditorAction
    | ChangeMassActionsTextBulkTextItemsAction
    | ChangeMassActionsTextBulkTitleTumblerAction
    | OpenMassActionsLinkBulkReplacementEditorAction
    | OpenMassActionsLinkDisplayedBulkReplacementEditorAction
    | CloseMassActionsLinkDisplayedBulkReplacementEditorAction
    | OnAcceptMassActionsLinkDisplayedBulkReplacementEditorAction
    | ChangeLinkDisplayedBulkEditorNewUrlAction
    | OnAcceptMassActionsImageAction
    | AcceptMassActionsBulkImageCreativeReplacementEditor
    | OpenMassActionsBulkImageCreativeReplacementEditorAction
    | ChangeMassActionsCalloutsRadioState
    | ChangeLinkDisplayedBulkEditorSelectedLinkAction
    | UpdateMassActionsImageCreativeAction
    | ChangeMassActionsSiteLinksRadio
    | OnAcceptMassActionsSiteLinksEditorAction
    | CloseMassActionsSiteLinksEditorAction
    | OnOpenMassActionsSiteLinksEditorAction
    | AcceptMassActionsSiteLinksEditorAction
    | OnMassActionsLinkDisplayedBulkReplacementEditorRadioButtonStateChangedAction
    | OpenMassActionsVideoBulkReplacementEditorAction
    | CloseMassActionsVideoBulkReplacementEditor
    | OnAcceptMassActionsVideoBulkReplacementEditor
    | OnMassActionsVideoBulkReplacementEditorRadioButtonStateChanged
    | OpenMassActionsVideoCreativeBulkReplacementEditorAction
    | CloseMassActionsVideoCreativeBulkReplacementEditor
    | OnAcceptMassActionsVideoCreativeBulkReplacementEditor
    | OnMassActionsVideoCreativeBulkReplacementEditorRadioButtonStateChanged
    | OnAcceptMassActionsVideoAction
    | OpenMassActionsTrackingParametersBulkReplacementEditorAction
    | CloseMassActionsTrackingParametersBulkReplacementEditorAction
    | OnAcceptMassActionsTrackingParametersBulkReplacementEditorAction
    | ChangeMassActionsTrackingParametersBulkSiteLinksTumblerAction
    | ChangeMassActionsTrackingParametersBulkKeyOrValueSelectAction
    | ChangeMassActionsTrackingParametersBulkTargetParametersAction
    | ChangeMassActionsTrackingParametersBulkNewParametersAction
    | OnAcceptMassActionsCalloutsAction
    | AcceptMassActionsLinkDisplayedBulkReplacementEditorAction
    | OnSaveMassActionsTextBulkReplacementEditorAction
    | OpenMassActionsTurbolandingBulkReplacementEditorAction
    | CloseMassActionsTurbolandingBulkReplacementEditor
    | OnAcceptMassActionsTurbolandingBulkReplacementEditor
    | OnMassActionsTurbolandingBulkReplacementEditorRadioButtonStateChanged
    | OpenMassActionsBulkCpmImageCreativeReplacementEditorAction
    | CloseMassActionsCpmCreativeBulkReplacementEditor
    | OnAcceptMassActionsCpmCreativeBulkReplacementEditor
    | OnAcceptMassActionsPixelBulkReplacementEditor
    | CloseMassActionsPixelBulkReplacementEditor
    | OnOpenMassActionsCountersAction
    | OnAcceptMassActionsCountersBulkReplacementEditor
    | CloseMassActionsCountersBulkReplacementEditor;
